import { Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { MyTrans } from '@halo/ui-react';
import { useUserInfo } from '@/scripts/hooks';
import { MsgUserText } from '../../msg-parts';

export interface MsgGroupSendMsgAdminContentProps {
  message: Msg;
}

export const MsgGroupSendMsgAdminContent = memo(function MsgGroupSendMsgAdminContent({
  message,
}: MsgGroupSendMsgAdminContentProps) {
  const { operator_user_id, send_permission } = message.payload;

  const { user: operatorUser } = useUserInfo(operator_user_id);

  return (
    <MyTrans
      i18nKey="chat.groupMessageSendMsgAdminText"
      components={{
        actionUser: <MsgUserText userName={operatorUser?.name || ''} userId={operator_user_id} />,
        action: <Text as="span" color="fg.muted" />,
        other: (
          <Text as="span" color="fg.muted" px="1">
            {send_permission === 1 ? (
              <MyTrans i18nKey="chat.groupMessageSendMsgAdminTextEveryone" />
            ) : (
              <MyTrans i18nKey="chat.groupMessageSendMsgAdminTextOther" />
            )}
          </Text>
        ),
      }}
    ></MyTrans>
  );
});
